(function (){
    'use strict';

    angular
        .module('statistics', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'ngAnimate',
            'ui.footable',
        ]);
})();